<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="dataTables_filter mb-2">
                        <label class="d-flex mb-0">
                            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchStock" @keyup.enter="filterSearchStock">
                            <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchStock">
                                <i class="fas fa-search"></i>
                            </button>
                        </label>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-4 mb-2"> 
                            <date-range-picker class="w-100"
                                :minDate="minDate"
                                ref="picker"
                                v-model="dateRange"
                                :opens="'right'"
                                :autoApply="true"
                                :showDropdowns="true" 
                                :always-show-calendars="false"
                                :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                                @showCustomRange="showCustomRangeCalendars=true"
                                @update="filterByDate">
                            </date-range-picker>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" >
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect v-model="selectedSubCategory" :options="subCategory" label="text" track-by="id" :searchable="true" :show-labels="false" openDirection="below" @select="filterSubCategory"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link ml-3 text-primary" @click="clearFilter">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <div class="fs-xs fw-300 text-right pt-2 pb-2">
                                        <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" @click="showAllDetails">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}}</button>
                                    </div>
                                    <b-table id="tblStockList" striped hover bordered :fields="fields" :items="stockItems"  responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" :id="'ivt' + data.index" @click="showDetails($event)">{{data.item.name}}</a>
                                            <div class="mt-1 stockDetail" style="display: none;">
                                                <table class="table table-sm table-hover table-bordered table-striped">
                                                    <tr>
                                                        <th>{{$t('table.header.date')}}</th>
                                                        <td>{{convertTimestampToDateTime(data.item.createDate)}}</td>    
                                                    </tr>
                                                    <tr>
                                                        <th>{{$t('label.order_number')}}</th>
                                                        <td>{{data.item.orderID == 0 ? $t('salon_report.stock.manual') : insertLeadingZero(data.item.orderID)}}</td>    
                                                    </tr>
                                                    <tr>
                                                        <th>{{$t('table.header.remark')}}</th>
                                                        <td>{{data.item.detail == "" ? "-" : data.item.detail}}</td>    
                                                    </tr>
                                                </table>    
                                            </div>
                                        </template>
                                        <template #cell(action)="data">
                                            <span class="badge" :class="getAction(data.item.quantity)== 1 ? 'badge-primary' : 'badge-warning'">
                                                {{getAction(data.item.quantity)== 1 ? $t('salon_report.stock.stock_in') : $t('salon_report.stock.stock_out')}}</span>
                                        </template>
                                        <template #cell(category)="data">
                                            {{getCategoryText(data.item.category, category)}}
                                        </template>
                                        <template #cell(folderID)="data">
                                            {{data.item.folderID == null ? '-' : getCategoryText(data.item.folderID, subCategory)}}
                                        </template>
                                        <template #cell(basePrice)="data">
                                            {{!("basePrice" in data.item) ? '-' : formatPrice(data.item.basePrice)}}
                                        </template>
                                        <template #cell(price)="data">
                                           {{formatPrice(data.item.price)}}
                                        </template>
                                        <template #cell(total)="data">
                                            {{formatPrice(getTotalPrice(data.item.price, data.item.quantity))}}
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

import {getCategoryText, setCategoryLabel, handleSessionExpired, setReturnData, getSubcategory} from './../../../../assets/js/dashboard/dashboard'
import {convertDateToString, convertTimestampToDateTime, convertDateToTimestamp, insertLeadingZero, formatPrice} from './../../../../assets/js/dashboard/utilities'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'stockList',
    components:{
        DateRangePicker,
    },
    props:{
        productItems: { type: Array },
    },
    data(){
        let startDate = moment().startOf('year')
        let endDate = moment().endOf('year')
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            isSpinnerShow: false,
            status: "",
            dateRange: { startDate, endDate }, dateFilter: "",
            categoryFilter: "", subCategoryFilter: "",
            searchStock: "", searchStockFilter: "",
            outlet: [], selectedOutlet: {},
            categoryList: "",
            category: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.category')})}],
            selectedTab: "all",
            subCategories: [], subCategory: [], selectedSubCategory: {},
            stockItems: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            isExpand: "Expand", 
            exportHeaders: [], exportData: [], exportFileName: "", stockExportData: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "action", label: "", thClass: 'thead-themed align-middle'},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle'},
                { key: "folderID", label: this.$i18n.t('table.header.subcategory'), thClass: 'thead-themed align-middle'},
                // { key: "basePrice", label: this.$i18n.t('label.cost'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('label.cost'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "quantity", label: this.$i18n.t('table.header.quantity'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "total", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.price')}), thClass: 'thead-themed align-middle', sortable: true},
                { key: "balance", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.date').toUpperCase()] = "date"
            ret[this.$i18n.t('label.order_number').toUpperCase()] = "orderNumber"
            ret[this.$i18n.t('table.header.title').toUpperCase()] = "title"
            ret[this.$i18n.t('table.action').toUpperCase()] = "action"
            ret[this.$i18n.t('table.header.category').toUpperCase()] = "category"
            ret[this.$i18n.t('table.header.subcategory').toUpperCase()] = "subCategory"
            // ret[this.$i18n.t('label.cost').toUpperCase()] = "cost"
            ret[this.$i18n.t('label.cost').toUpperCase()] = "price"
            ret[this.$i18n.t('table.header.quantity').toUpperCase()] = "quantity"
            ret[this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.price')}).toUpperCase()] = "total"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setLabel()
            var b = Object.assign({}, this.selectedSubCategory)
            this.selectedSubCategory = this.subCategory.filter(obj=> obj.id == b.id)[0]

            this.setExportData(this.stockExportData)
        }
    },
    methods:{
        convertTimestampToDateTime(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24);
        },
        formatPrice(price){
            return formatPrice(price);
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        getTotalPrice(price, quantity){
            var t = parseFloat(price).toFixed(2) * parseInt(quantity);
            var  total = t.toString() == "0" ? 0 : t;
            return total;
        },
        getCategoryText(id, category){
            return getCategoryText(id, category);
        },
        getAction(quantity){
            return Math.sign(quantity)
        },
        showDetails(e, type){
            var link = e.target;
            var detailsDiv = link.nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var detailsContainer = document.getElementById("tblStockList").querySelectorAll(".stockDetail");

            for(var i=0; i<detailsContainer.length; i++){
                if(detailsContainer[i].style.display == 'none'){
                    hideCount++
                }
            }
            this.isExpand = hideCount == this.stockItems.length ? "Expand" : "Collapse"
        },
        showAllDetails(){
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("tblStockList").querySelectorAll(".stockDetail");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpand){
                    if(detailsContainer[i].style.display == 'none'){
                        detailsContainer[i].style.display = 'block'
                    }
                }else{
                    if(detailsContainer[i].style.display == 'block'){
                        detailsContainer[i].style.display = 'none'
                    }
                }
            }
        },
        async getStockItem(strFilter){
            console.log(this.status)
            let $vm = this;
            const QUERY_STRING =  ($vm.status == "stockList" ? "?" : "?" + $vm.status + "=1&") + "page=" + $vm.page + strFilter;
            const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.stock;     
                $vm.totalEntries = response.data.count; 
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        async setStockItem(status, strFilter){
            this.status = status
            this.isSpinnerShow = true;

            var stockItem = await this.getStockItem(strFilter);
            if(stockItem.length != 0){
                for(var i=0; i<stockItem.length; i++){
                    for(var j=0; j<this.productItems.length; j++){
                        if(this.productItems[j].itemID == stockItem[i].itemID){
                            stockItem[i]["basePrice"] = this.productItems[j].basePrice;
                            break;
                        }
                    }
                }
            }else{
                stockItem = [];
            }
            var retData = setReturnData(stockItem, stockItem.length, this.page)
            this.stockItems = retData.result;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            await this.getExportData(strFilter)
        },
        clearFilter(){
            this.isExpand = "Expand"
            this.searchStockFilter = this.searchStock = this.categoryFilter = this.subCategoryFilter = ""
            this.selectedSubCategory = this.subCategory[0];
            this.selectedTab = "all"

            let startDate = moment().startOf('year')
            let endDate = moment().endOf('year')

            this.dateRange = {startDate, endDate}

            this.dateFilter = "&startDate=" + moment(startDate).format(this.$msg.CST.DATE_FORMAT) + "&endDate=" + moment(endDate).format(this.$msg.CST.DATE_FORMAT);
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterSearchStock(){
            this.searchStockFilter = this.searchStock == "" ? "" : "&search=" + this.searchStock;
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterByDate(date){
            var startDate = moment(date.startDate).format(this.$msg.CST.DATE_FORMAT);
            var endDate = moment(date.endDate).format(this.$msg.CST.DATE_FORMAT);

            this.dateFilter = "&startDate=" + startDate + "&endDate=" + endDate;
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        async filterCategory(item){
            this.page = 0;
            this.selectedTab = item;
            this.categoryFilter = item == "all"? "" : "&category=" + item;
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);

            this.subCategories = await getSubcategory(this, 'product', this.categoryFilter);
            this.setLabel()
            this.selectedSubCategory = this.subCategory[0]
        }, 
        filterSubCategory(item){
            this.selectedSubCategory = item;
            this.subCategoryFilter = item.id == 0 ? "" : "&folderID=" + item.id;
            this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterStockItem(date, category, subCategory, search){
            var strFilter = date + category + subCategory + search;
            this.setStockItem(this.$parent.selectedTab, strFilter);
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1;
                this.filterStockItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter); 
            }
        },
        async getExportData(strFilter){
            let $vm = this;
            const QUERY_STRING =  ($vm.status == "" ? "?" : "?" + $vm.status + "=1") + strFilter;
            const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.stock;     
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            if(result.length != 0){
                for(var i=0; i<result.length; i++){
                    for(var j=0; j<this.productItems.length; j++){
                        if(this.productItems[j].itemID == result[i].itemID){
                            result[i]["basePrice"] = this.productItems[j].basePrice;
                            break;
                        }
                    }
                }
            }else{
                result = [];
            }
            this.stockExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    date: convertTimestampToDateTime(data[i].createDate),
                    orderNumber: data[i].orderID == 0 ? this.$i18n.t('salon_report.stock.manual') : insertLeadingZero(data[i].orderID),
                    title: data[i].name,
                    action: this.getAction(data[i].quantity) == 1 ? this.$i18n.t('salon_report.stock.stock_in') : this.$i18n.t('salon_report.stock.stock_out'),
                    category: getCategoryText(data[i].category, this.category),
                    subCategory: data[i].folderID ==  null ? '-' : getCategoryText(data[i].folderID, this.subCategory),
                    // cost: !("basePrice" in data[i]) ? 0 : data[i].basePrice,
                    price: data[i].price,
                    quantity: data[i].quantity,
                    total: this.getTotalPrice(data[i].price, data[i].quantity),
                    balance: data[i].balance
                })
            }

            this.exportData = exportData;

            var strDate =  moment(this.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.dateRange.endDate).format(this.$msg.CST.DATE_FORMAT);

            var arrType = this.$i18n.messages[this.$i18n.locale].tab.stockTabs
            var type = arrType.filter(obj => obj.id == this.status)[0]


            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_stock`) + " (" + type.text + ")"
            this.exportHeaders = [
                header, 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (this.selectedOutlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : this.selectedOutlet.text),
                " "];
            this.exportFileName =  header.split(" ").join("_") + strDate  +  this.$msg.REPORT.CSV
        },
        setLabel(){
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.product)
            this.subCategory = setCategoryLabel(this, false, this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')}), this.subCategories)
        },
    },
    async mounted(){
        let $vm = this;
        var startDate = moment($vm.dateRange.startDate).format($vm.$msg.CST.DATE_FORMAT);
        var endDate = moment($vm.dateRange.endDate).format($vm.$msg.CST.DATE_FORMAT);
        $vm.dateFilter = "&startDate=" + startDate + "&endDate=" + endDate;

        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.setStockItem('stockList', $vm.dateFilter);
        
        $vm.subCategories = await getSubcategory($vm, 'product', "");
        $vm.setLabel()
        $vm.selectedSubCategory = $vm.subCategory[0]
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
</style>